<template>
  <section class="qv-card">
    <p class="qv-section-title">Dados da Última Venda</p>

    <div class="qv-stat-row" v-if="loading">
      <div class="qv-stat" v-for="n in 3" :key="'sl-' + n">
        <span class="qv-sk qv-sk-label"></span>
        <span class="qv-sk qv-sk-value"></span>
      </div>
    </div>

    <div class="qv-stat-row" v-else>
      <div class="qv-stat">
        <span class="qs-label">Data</span>
        <span class="qs-value date-value">{{ display(formatDate(sale.date)) }}</span>
      </div>

      <div class="qv-stat">
        <span class="qs-label">Quantidade</span>
        <span class="qs-value">
          {{ display(sale.quantity) }}
          <span class="u">un</span>
        </span>
      </div>

      <div class="qv-stat">
        <span class="qs-label">Valor</span>
        <span class="qs-value">{{ display(formatCurrency(sale.value)) }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'QvLastSale',

    props: {
        lastSale: {
            type: Object,
            default: null,
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        sale() {
            return this.lastSale || {};
        },
    },

    methods: {
        display(value) {
            return value === null || value === undefined || value === ''
                ? '—'
                : value;
        },

        formatDate(value) {
            if (!value) {
                return '';
            }

            const raw = String(value).substring(0, 10);
            const [year, month, day] = raw.split('-');

            if (!year || !month || !day) {
                return '';
            }

            return `${day}/${month}/${year}`;
        },

        formatCurrency(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }

            return Number(value).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';
</style>
